<template>
  <div>
    <div class="content-title">
      <div>איזה כיף שיצאנו לדרך!</div>
    </div>
    <div class="content-text">
      <div>
        אנחנו מקווים שהשירות יעזור לך לצמוח כלכלית ואנחנו כאן לאורך הדרך, זמינים לך בכל שאלה.
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'BeginningPeriodContent',
};
</script>

<style lang="scss" scoped>

  .content-text {
    line-height: 1.5;
  }

  .content-title {
    margin-bottom: 16px;
    font-family: GretaSans,serif;
    font-size: 24px;
    line-height: 24px;
  }

</style>
